// extracted by mini-css-extract-plugin
module.exports =  {"header":"_1c9529d521--header--MOif3","controls":"_1c9529d521--controls--kM_l8"};